import { useState, useEffect } from 'react';
import { adminAPI } from '../services/api';

export interface Company {
  id: string;
  name: string;
  domain: string;
  contactEmail: string;
  industry?: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  lastLoginAt?: string;
  planName?: string;
  planPrice?: number;
  planId?: number;
  planFeatures?: any;
  subscriptionStatus?: string;
  subscriptionEndDate?: string;
  nextBillingDate?: string;
  /** Last invoice status from Zoho (e.g. paid, overdue, sent); same as fetchCompanySubscriptionDetails */
  lastInvoiceStatus?: string;
  chatEnabled?: boolean;
  chatLimitDaily?: number;
  chatCostPerToken?: number;
}

export const useCompanies = () => {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      setError(null);
      const response = await adminAPI.getCompanies();
      
      // Backend now filters out the root company, so no need for frontend filtering
      setCompanies(response.data);
    } catch (err: any) {
      console.error('Error fetching companies:', err);
      setError(err.message || 'Failed to fetch companies');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return { companies, loading, error, refetch: fetchCompanies };
}; 